<template>
  <v-container>
    <v-layout justify-center style="flex-wrap: wrap">
      <v-btn small @click="createAffiliazione" color="primary">{{
        $t("create_affiliazion")
      }}</v-btn>
    </v-layout>
    <DataTables  @editAffiliazione="editAffiliazione" @viewAffiliazione="viewAffiliazione"
      @copyAffiliazione="copyAffiliazione" :headers="headers" :tableData="tableData"></DataTables>
    <edit-affiliazione ref="gestAffiliazioneDialog" @isUpdated="loadTable"></edit-affiliazione>
  </v-container>
</template>

<script>
import gestAffiliazione from "@/app/ente/gestAffiliazione.vue";
import DataTables from "@/components/base/DataTables.vue";
import Swal from "sweetalert2";

export default {
  name: "list-affiliazioni",
  components: {
    DataTables,
    "edit-affiliazione": gestAffiliazione,
  },
  data() {
    return {
      headers: [
        { text: this.$t("code"), value: "affiliazione" },
        { text: this.$t("description"), value: "descr" },
        { text: this.$t("options"), value: "options", type: "buttons" },
      ],
      tableData: [],
    };
  },

  methods: {
    viewAffiliazione(item) {
      this.$refs.gestAffiliazioneDialog.open("VIEW", item.affiliazione);
    },
    createAffiliazione() {
      this.$refs.gestAffiliazioneDialog.open("ADD", null);
    },
    editAffiliazione(item) {
      this.$refs.gestAffiliazioneDialog.open("EDIT", item.affiliazione);
    },
    copyAffiliazione(item) {
      this.$refs.gestAffiliazioneDialog.open("COPY", item.affiliazione);
    },

    loadTable() {
      let _ = this;
      let url = "/auth/ente/listAffiliazioni";
      _.tableData = [];
      this.chiamataAxios("POST", url).then((response) => {
        // Aggiunge actions e icona validazione
        _.tableData = response.data.map(function (item) {
          item.options = [
            {
              icon: "mdi-magnify",
              color: "green",
              function: "viewAffiliazione",
            },
            {
              icon: "mdi-pencil",
              color: "primary",
              function: "editAffiliazione",
            },
            {
              icon: "mdi-content-copy",
              color: "primary",
              function: "copyAffiliazione",
            },
          ];
          return item;
        });
      });
    },
  },
  mounted() {
    this.loadTable();
  },
};
</script>